import { InputNumber as AntdInputNum, InputNumberProps } from "antd";
import React, { forwardRef } from "react";
import styled from "styled-components";

export interface CustomInputNumberProps extends InputNumberProps {}
const InputNumber: React.FC<CustomInputNumberProps> = forwardRef<
  HTMLInputElement,
  CustomInputNumberProps
>((props, ref) => {
  return (
    <Input
      {...props}
      ref={ref}
      precision={0}
      formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
      parser={(value) => value?.replace(/\$\s?|(,*)/g, "") || ""}
    />
  );
});
export default InputNumber;
const Input = styled(AntdInputNum)`
  color: black;
  input {
    color: black;
  }
  width: 100%;
`;
